import React from "react";
import { connect } from "react-redux";
import { Transition, Segment, Header, Button } from "semantic-ui-react";
import { preinscripcionesOps } from "../ducks/preinscripciones";
import TablaPreinscripciones from "./preinscripciones/TablaPreinscripciones";

class Preinscripciones extends React.Component {
  state = { visible: false };

  componentDidMount() {
    this.setState(state => ({ visible: true }));
    this.props.obtenerPreinscripcionesPorColegio();
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    return {
      totalInscripciones: nextProps.datos.reduce(
        (anterior, actual) => anterior + actual.num,
        0
      )
    };
  }

  componentWillUnmount() {
    this.props.limpiarPreinscripcionesPorColegio();
  }

  handleVolver = () => this.props.history.goBack();

  render() {
    return (
      <Transition.Group animation="scale" duration={250}>
        {this.state.visible && (
          <React.Fragment>
            <Segment basic>
              <Button
                content="Cerrar"
                floated="right"
                color="pink"
                icon="cancel"
                onClick={this.handleVolver}
              />
              <Header inverted as="h2">
                Listado de Preinscripciones: {this.state.totalInscripciones}
              </Header>
            </Segment>
            <TablaPreinscripciones datos={this.props.datos} />
          </React.Fragment>
        )}
      </Transition.Group>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  datos: state.preinscripciones.preinscripcionesPorColegio
});

const mapDispatchToProps = {
  obtenerPreinscripcionesPorColegio:
    preinscripcionesOps.obtenerPreinscripcionesPorColegio,
  limpiarPreinscripcionesPorColegio:
    preinscripcionesOps.limpiarPreinscripcionesPorColegio
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Preinscripciones);



// WEBPACK FOOTER //
// ./src/pages/Preinscripciones.jsx